
export const BaseUrl = () => {
    const base = process.env.REACT_APP_STAGE === 'prod' ? 'https://api.kardia.com' : 'https://api-staging.kardia.com';
          return base;
}

export const AuthToken = () => {
    const token = localStorage.getItem("jwtToken").replaceAll('"','');
          return token;
}